import { useState } from "react";
import { api, callableErrorMessage } from "../lib/api";
import { useAuth } from "../lib/auth";
import { track } from "../lib/analytics";

type Props = {
  tenantId: string;
  amount: number;
  reason: string;
  frequency?: number;
  frequencyType?: "days" | "months";
  buttonLabel?: string;
};

export function SubscriptionCheckoutButton({
  tenantId,
  amount,
  reason,
  frequency = 1,
  frequencyType = "months",
  buttonLabel
}: Props) {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const start = async () => {
    const payerEmail = window.prompt(
      "Email de tu cuenta Mercado Pago (con esa cuenta vas a iniciar sesion al pagar):",
      user?.email ?? ""
    );
    if (!payerEmail || !payerEmail.includes("@")) {
      setError("Email requerido y debe ser valido.");
      return;
    }
    setBusy(true);
    setError(null);
    track("subscription_checkout_started", { tenant_id: tenantId, amount });
    try {
      const res = await api.createSubscription({
        tenantId,
        amount,
        reason,
        frequency,
        frequencyType,
        payerEmail
      });
      track("subscription_checkout_redirecting", {
        tenant_id: tenantId,
        subscription_id: res.data.subscriptionId
      });
      window.location.href = res.data.initPoint;
    } catch (err) {
      track("subscription_checkout_failed", {
        code: (err as { code?: string })?.code ?? "unknown"
      });
      setError(callableErrorMessage(err));
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <button onClick={start} disabled={busy} className="btn-primary">
        {busy
          ? "Redirigiendo a Mercado Pago…"
          : buttonLabel ?? `Suscribirme $${amount.toLocaleString("es-CL")}/${frequencyType === "months" ? "mes" : "día"}`}
      </button>
      {error && (
        <div className="rounded-xl bg-red-50 px-3 py-2 text-xs text-red-700">{error}</div>
      )}
    </div>
  );
}
